import { graphql } from "@/gql";

export const clientAppointmentsFragment = graphql(`
  fragment ClientAppointments on Query {
    clients {
      nodes {
        id
        accountId
        invitedAt
        createdAt
        profile {
          id
          firstName
          avatarUrl
        }
      }
    }
    appointments(status: UPCOMING, date: $currentDate) {
      date
      appointments {
        ...AppointmentPanel
      }
    }
  }
`);

export const coachFragment = graphql(`
  fragment Coach on Coach {
    id
    profile {
      id
      fullName
    }
    trialWillEnd
    subscriptionSuspended
    subscriptionStatus
  }
`);

export const clientFragment = graphql(`
  fragment Client on Client {
    id
    profile {
      id
      fullName
      avatarUrl(variant: THUMB)
    }
    programForDate(date: $currentDate) {
      id
      name
      startDate
      endDate
    }
    activities(first: 5) {
      nodes {
        id
        message
        notifiableType
        params
        createdAt
      }
    }
    mealActivitiesStatus
    weightActivitiesStatus
    learningModuleActivitiesStatus
  }
`);
